import AnswerSheetTypeMultipleSubQuestionsYesNoAnswerChoice from './AnswerSheetTypeMultipleSubQuestionsYesNoAnswerChoice';

export default AnswerSheetTypeMultipleSubQuestionsYesNoAnswerChoice;
